import MLList from '../../../Mattertags/List/MLList'

const TagsEditorMattertags = () => {
  return <MLList editorMode />
}
export default TagsEditorMattertags
